// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Wlpi","inner":"Footer_inner__3qwx3","nextIcon":"Footer_nextIcon__Q_VrJ","innerLeft":"Footer_innerLeft__2G-t5"};